package app.api

import app.client
import app.model.Company
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import io.ktor.http.*
import kotlinx.coroutines.*

class CompaniesApi : RootStore<List<Company>>(emptyList(), job = Job()) {
    val handler = handle {
        client.get(Routing.Companies()).body<List<Company>>()
    }

    val postCompany = handle { companies, name: String ->
        val company = client.post(Routing.Companies.New(name = name)).body<Company>()
        companies + company
    }

    val putCompany = handle { companies, company: Company ->
        val companyResp = client.put(Routing.Companies.Update(id = company.id, name = company.name)).body<Company>()
        companies.map { if (it.id == company.id) companyResp else it }
    }

    val deleteCompany = handle { companies, id: Int ->
        val resp = client.delete(Routing.Companies.Id(id = id))
        require(resp.status == HttpStatusCode.NoContent)
        companies.filter { company -> company.id != id }
    }
}
